import React from "react";
import { Button } from "@wac-ui-dashboard/wac_component_library";
import Select from "react-select";
import useRevertModal from "./useRevertModal";

function RevertModal({
  handleClose,
  refetch,
  selectedId,
  dispatch,
  updateConfig,
}) {
  const { formik, Options, getFieldError } = useRevertModal({
    refetch,
    handleClose,
    selectedId,
    dispatch,
    updateConfig,
  });
  return (
    <>
      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Select an option to revert
        </label>
        <div className="input-wrap">
          <Select
            id="revert"
            name="revert"
            placeholder={"Select"}
            classNamePrefix="pro-input"
            className={`pro-input lg  ${getFieldError("revert") && " error"}`}
            options={Options}
            onBlur={formik?.handleBlur("revert")}
            onChange={(value) => {
              formik?.setFieldValue("revert", value?.value || null);
            }}
          />
          {formik.touched.revert && formik.errors.revert && (
            <span className="error-text">{formik.errors.revert}</span>
          )}
        </div>
        <div
          className={`col-12 pro-d-flex pro-justify-end pro-mt-4`}
        >
          <Button className={"pro-btn-link lg pro-px-5"} onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className={"pro-btn-primary lg pro-ms-3"}
            type="submit"
            onClick={formik?.handleSubmit}
          >
            {"Submit"}
          </Button>
        </div>
      </div>
    </>
  );
}

export default RevertModal;
